import type { IntentSdkContext, IntentStatusArgs } from '@/types/sdk/experimental/crosschain/crosschainIntentTypes'
import type { IntentStatusResponse } from '@vaultsfyi/common/schemas'

export const getIntentStatus = async (
  ctx: IntentSdkContext,
  { crosschainTransactionId }: IntentStatusArgs
): Promise<IntentStatusResponse> => {
  const params = new URLSearchParams({ crosschainTransactionId, provider: ctx.provider })
  const response = await fetch(`${ctx.base}/intent/status?${params.toString()}`)

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error?.message ?? 'Failed to fetch crosschain transaction status')
  }

  return response.json()
}
